<template>
   <div id="news-page-container" v-if="announcement">
      <div class="news-page-wrapper">
         <div class="gts-logo d-none d-md-flex" @click="handlerRouteToAgentHome">
            <i class="gts-type"> </i>
            <span>{{ $t("announcement_homePage") }}</span>
         </div>

         <div class="asdad">
            <router-link to="/">
               <div class="gts-logo-mobile d-sm-block d-lg-none">
                  <img :src="`${this.$constants.cdn}/logo/${$constants.brand.cssCode}-logo.svg`" alt="Global Travel Services" id="gts-logo-mobile" />
               </div>
            </router-link>
         </div>
         <div class="news-page-header-wrapper">
            <span class="news-page-header-title">{{ announcement.name }} </span>
            <div class="document-informations-wrapper">
               <div class="document-information">
                  <span>{{ announcement.insertedDatetime | FormatterDD_MMMM_YYYY }} {{ announcement.insertedDatetime | FormatterTime }}</span>
                  <i></i>
                  <span>
                     {{ $t("announcement_updateTime") }} {{ announcement.updatedDatetime | FormatterDD_MMMM_YYYY }}
                     {{ announcement.updatedDatetime | FormatterTime }}
                  </span>
               </div>

               <div class="document-cta-wrapper">
                  <i class="gts-icon icon-document-copy gts-animation no-print" @click="handlerCopyUrl"></i>
                  <i class="gts-icon icon-document-print gts-animation no-print" @click="handlerPrintPage"></i>
               </div>
            </div>
         </div>

         <section class="news-page-body-wrapper">
            <div class="image-wrapper" v-if="isImageExist.landscape">
               <div class="image-container">
                  <img :src="`${$constants.cdn}/announcements/${announcement.id}L.jpg`" alt="" />
               </div>
               <span class="show-original no-print" @click="handlerTriggerFullImage(announcement.id)">
                  {{ $t("announcement_showOriginalImage") }}
               </span>
            </div>

            <div class="news-page-content-wrapper" v-html="announcement.detailHtml"></div>
         </section>

         <section class="news-page-footer-wrapper">
            <div class="social-links-wrapper">
               <a href="https://www.facebook.com/gtsfly" target="_blank">
                  <i class="gts-icon icon-icon-facebook icon-sm"></i>
               </a>
               <a href="https://www.instagram.com/gtsfly/" target="_blank">
                  <i class="gts-icon icon-icon-instagram icon-sm"></i>
               </a>
               <a href="https://www.linkedin.com/company/gtsfly/" target="_blank">
                  <i class="gts-icon icon-icon-linkedin icon-sm"></i>
               </a>
            </div>
            <span class="copyright"> &copy; Reisetech {{ year }} </span>
         </section>
      </div>
   </div>
</template>

<script>
// import Main from "@/components/unitary/Main.vue";
import { announcementService } from "@/service/index.js";
import moment from "moment";

export default {
   name: "NewsPage",

   data() {
      return {
         uuid: this.$route.query.a,
         announcement: null,
         env: process.env.VUE_APP_ENV,
         year: moment().format("YYYY"),
         isImageExist: {
            thumbnail: false,
            landscape: false,
         },
      };
   },
   created() {
      announcementService.getAnnouncement({ uuid: this.uuid }).then((response) => {
         if (this.uuid == "responsivetest") {
            response = {
               item: {
                  uuid: "5f233dd1-c32d-487f-a4f5-195e03806d5e",
                  status: 1,
                  category: 1,
                  entityType: 2,
                  userType: -1,
                  application: -1,
                  language: 3,
                  index: 950,
                  name: "📣 SunExpress Airlines: Flugtarife, Umbuchung, Sitzplatzauswahl sind jetzt im GTS-System verfügbar!",
                  description: "",
                  briefHtml: "<p>Flugtarife, Umbuchung und Sitzplatzauswahl</p>",
                  detailHtml:
                     '<p style="line-height:115%;">&nbsp;</p><p style="line-height:115%;"><span lang="TR" dir="ltr">Die Flugtarife von SunExpress Airlines stehen in unserem GTS-Reservierungssystem zum Verkauf verfügbar.</span></p><p style="line-height:115%;">&nbsp;</p><p style="line-height:115%;"><span lang="TR" dir="ltr">Wir haben auch die notwendigen Anwendungen hinzugefügt, mit denen Sie Vorgänge wie „Sitzplatzauswahl“ und „Umbuchung“ schnell und einfach über das System ausführen können.</span></p><p style="line-height:115%;">&nbsp;</p><figure class="table" style="width:99.28%;"><table class="ck-table-resized"><colgroup><col style="width:26.29%;"><col style="width:29.73%;"><col style="width:43.98%;"></colgroup><tbody><tr><td><p style="text-align:center;"><span style="font-size:14px;">SunEco</span></p></td><td><p style="text-align:center;"><span style="font-size:14px;">SunClassic</span></p></td><td><p style="text-align:center;"><span style="font-size:14px;">SunPremium</span></p></td></tr><tr><td><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅30kg (int. Flüge), 20kg (Antalya, Bodrum, Dalaman), 15kg (inlandsflüge)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅1 großes Handgepäckstück (max. 8kg und 55x40x23cm)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Online Check-in (kostenpflichtiger Flughafen Check-in)</span></span></p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p></td><td><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅35kg (int. Flüge), 25kg (Antalya, Bodrum, Dalaman), 20kg (inlandsflüge)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅1 großes Handgepäckstück (max. 8kg und 55x40x23cm)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅SunFlex 7 - Umbuchung ohne Gebühr bis zum 7 Tage vor Abflug (+Preisdifferenz)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Snack Box &amp; 1 stilles Wasser</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Standardsitzplatzreservierung</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Online Check-in (kostenpflichtiger Flughafen Check-in)</span></span></p><p>&nbsp;</p></td><td><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅40kg (int. Flüge), 30kg (Antalya, Bodrum, Dalaman), 25kg (inlandsflüge)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅1 großes Handgepäckstück (max. 8kg und 55x40x23cm)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅SunFlex 3 - Umbuchung ohne Gebühr bis zum 3 Tage vor Abflug (+Preisdifferenz)</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Flughafen Check-in</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Premium Menü und 2 Getränke</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Online Check-in</span></span></p><p><span style="font-family:;font-size:14px;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✅Sitzplatz mit zusätzlicher Beinfreiheit (XLeg Sitz)</span></span></p></td></tr></tbody></table></figure><p style="line-height:115%;"><span style="font-family:;"><span style="line-height:107%;" lang="TR" dir="ltr" segoe="" ui="">✈</span><span style="line-height:107%;" lang="TR" dir="ltr" calibri="">️️️</span></span><span lang="TR" dir="ltr">️</span><span style="font-family:;"><span lang="TR" dir="ltr" segoe="" ui="">🔎</span></span><span lang="TR" dir="ltr"> Wenn Sie weitere Informationen zu den von SunExpress Airlines angebotenen Tarifen, Umbuchungen und Stornierungsregeln erhalten möchten,&nbsp;</span>klicken Sie <a href="https://cdn.sunexpress.com/wp-content/uploads/sites/6/2020/12/16093055/tarifinformationen.pdf"><u>hier</u></a>.</p>',
                  id: 803,
                  dbState: 1,
                  insertedUserId: 482,
                  insertedUserEmail: null,
                  insertedDatetime: "2024-09-06T10:03:20.243",
                  updatedUserId: 482,
                  updatedUserEmail: null,
                  updatedDatetime: "2024-09-18T08:34:37.483",
               },
               uuid: null,
               result: {
                  success: true,
                  app: "",
                  service: "",
                  code: "SUCCESS",
                  subCode: "OK",
                  message: "",
               },
               id: 0,
               ids: null,
            };
         }
         this.announcement = response.item;
         this.checkIfImageExists(`${this.$constants.cdn}/announcements/${response.item.id}L.jpg`, (exists) => {
            if (exists) {
               this.isImageExist.thumbnail = false;
               this.isImageExist.landscape = true;
            } else {
               this.isImageExist.thumbnail = false;
               this.isImageExist.landscape = false;
            }
         });
      });
   },
   methods: {
      checkIfImageExists(url, callback) {
         const img = new Image();
         img.src = url;

         if (img.complete) {
            callback(true);
         } else {
            img.onload = () => {
               callback(true);
            };

            img.onerror = () => {
               callback(false);
            };
         }
      },
      handlerTriggerFullImage(identifier) {
         if (this.isImageExist.thumbnail) {
            window.open(`${this.$constants.cdn}/announcements/${identifier}.jpg`);
         } else if (this.isImageExist.landscape) {
            window.open(`${this.$constants.cdn}/announcements/${identifier}L.jpg`);
         }
      },
      handlerPrintPage() {
         window.print();
      },
      handlerRouteToAgentHome() {
         location.href = location.origin;
         // window.open(location.origin);
      },
      handlerCopyUrl() {
         const clipboardData = event.clipboardData || window.clipboardData || event.originalEvent?.clipboardData || navigator.clipboard;
         clipboardData.writeText(location.href);
         const urlCopied = {
            type: "SUCCESS",
            message: this.$i18n.t(`announcement_urlCopied`),
            count: false,
         };
         this.$store.commit("app/setNotification", urlCopied);
      },
   },
};
</script>
<style lang="scss">
.table {
   overflow-x: scroll !important;
}
</style>
<style lang="scss" scoped>
#news-page-container {
   display: flex;
   justify-content: center;

   @media print {
      .no-print,
      .no-print * {
         display: none !important;
      }
   }

   .news-page-wrapper {
      width: 960px;
      min-height: 100vh;
      background: var(--gray-50);
      padding: 2rem;
      position: relative;
      overflow-x: auto !important;

      @media print {
         padding: 1rem;
      }

      @media (min-width: 768px) {
         padding: 4rem;
         padding-top: 0;
      }

      .gts-logo {
         background-color: var(--primary);
         display: flex;
         flex-direction: column;
         position: sticky;
         top: 5.5rem;
         margin-left: -205px;
         width: 140px;
         height: 100px;
         display: flex;
         justify-content: center;
         align-items: center;
         border-top-left-radius: 8px;
         border-bottom-left-radius: 8px;
         cursor: pointer;

         &:hover {
            cursor: pointer;
            background-color: var(--accent-primary);
         }

         i.gts-type {
            display: block;
            width: 72px;
            height: 46px;
            background-image: url("data:image/svg+xml;base64,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");

            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
         }
         span {
            font-size: var(--small);
            font-weight: 600;
            //color: var(--gray-50);
            color: var(--gray-0);
            margin-top: 0.5rem;
         }
      }
      .gts-logo-mobile {
         margin-bottom: 1rem;
         cursor: pointer;
         border-bottom: 1px solid var(--gray-200);
         margin-bottom: 1.5rem;
         padding-bottom: 1rem;
      }
      .news-page-header-wrapper {
         position: relative;

         .news-page-header-title {
            color: var(--blue-700);
            font-size: var(--xxxlarge);
            font-weight: 800;
            line-height: 3.5rem;
            display: block;
         }
         .document-informations-wrapper {
            margin-top: 1rem;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid var(--gray-300);
            padding-bottom: 1rem;
            align-items: flex-end;

            .document-information {
               display: flex;
               align-items: center;
               height: fit-content;
               @media (max-width: 576px) {
                  flex-direction: column;
                  align-items: flex-start;
               }
               span {
                  font-size: 12px;
                  color: var(--gray-500);
                  height: fit-content;
               }
               i {
                  width: 6px;
                  height: 6px;
                  display: block;
                  background-color: var(--gray-500);
                  border-radius: 50%;
                  margin: 0 0.75rem;
                  @media (max-width: 576px) {
                     display: none;
                  }
               }
            }
            .document-cta-wrapper {
               display: flex;
               align-items: center;
               i {
                  cursor: pointer;
                  margin-left: 1rem;
               }
            }
         }
      }

      section.news-page-body-wrapper {
         margin: 2rem 0;
         .image-wrapper {
            position: relative;
            .image-container {
               overflow: hidden;
               border-radius: 8px;
               border-bottom-right-radius: 0;
            }
            span.show-original {
               position: absolute;
               right: 0;
               background-color: var(--gray-200);
               color: var(--gray-400);
               font-weight: 600;
               padding: 0.5rem 1rem;
               border-radius: 8px;
               border-top-left-radius: 0;
               border-top-right-radius: 0;
               font-size: 14px;
               cursor: pointer;
               &:hover {
                  background-color: var(--gray-800);
                  //color: var(--gray-50);
                  color: var(--gray-0);
               }
            }
         }
      }

      section.news-page-footer-wrapper {
         display: flex;
         justify-content: space-between;
         border-top: 1px solid var(--gray-300);
         padding-top: 1rem;
         margin-top: 4rem;
         align-items: center;
         .social-links-wrapper {
            display: flex;
            align-items: center;
            a {
               margin: 0.35rem;

               &:first-child {
                  margin-left: 0 !important;
               }
               &:last-child {
                  margin-right: 0 !important;
               }
            }
         }
         span.copyright {
            color: var(--gray-800);
         }
      }
   }
}
</style>

<style lang="scss">
.news-page-content-wrapper {
   margin-top: 4rem;
   font-size: 16px;
   line-height: 28px;

   ul {
      margin: 2rem 0;
      li {
         margin: 0px 0px 8px;
         line-height: 1.6em;
         color: var(--lavender-1000);
         position: relative;
         padding: 0px 0px 0px 16px;
         &::before {
            content: "";
            position: absolute;
            left: 0px;
            top: 10px;
            width: 8px;
            height: 8px;
            background: var(--lavender-1000);
            border-radius: 50%;
         }
      }
   }
   strong {
      font-weight: 600 !important;
   }
}
</style>
